const navs = [
  { name: "labels.organizations", url: "/administration/organizations/", icon: "globe", role: "admin" },
  { name: "labels.users", url: "/administration/users/", icon: "users", role: "admin" },
  { name: "labels.users-telegram", url: "/administration/users-telegram/", icon: "people-group", role: "admin" },
  { name: "labels.plugins", url: "/administration/plugins/", icon: "plug", role: "superuser" },
]

export default navs